import { glsInjectDynatrace } from '@gls-its-frontends/common/gls-dynatrace';
import { Environment } from '../enums/environment';

const STAGE_DYNATRACE_RUM_APP_ID: string = '50854838101c12f6';
const PROD_DYNATRACE_RUM_APP_ID: string = '7b2edeca1c99bf14';

const setUpDynatrace = (environment: Environment): void => {
    switch (environment) {
        case Environment.STAGE:
            glsInjectDynatrace(STAGE_DYNATRACE_RUM_APP_ID);
            break;
        case Environment.PROD:
            glsInjectDynatrace(PROD_DYNATRACE_RUM_APP_ID);
            break;
    }
};

export { setUpDynatrace };
